// @flow

import { SET_PENDING_STATUS, SET_SAVING_STATUS } from './constant';

const initialState = {
  isRegistrationPending: false,
};

export default function reducer(
  state: PendingStatusStoreType = initialState,
  action: SetPendingStatusActionType | SetSavingStatusActionType,
): any | PendingStatusStoreType {
  switch (action.type) {
    case SET_PENDING_STATUS:
      return {
        ...state,
        [action.payload.componentName]: action.payload.isPending,
      };
    case SET_SAVING_STATUS:
      return {
        ...state,
        currentSavingStatus: action.payload.currentSavingStatus,
      };
    default:
      return state;
  }
}
